import positions from './CustomStylingOptions/positions';

const templateDefaults = {
    version: 1,

    customCss: '',
    
    //Global defaults
    defaults: {
        blockWidth: 640,
        blockPadding: 0,

        headingSize: 3,

        font: 'calibri',
        fontSize: '12px',
        textColor: '#000000',

        boldText: false,
        italicText: false,
        textAlignment: 'left'
    }
};

const pageDefaults = {
    version: 1,
    
    
    style: {
        mediaId: '',
        color: '#f7f7f7',
        margin: 30,
        width: 950,
    }   
};

const blockDefaults = {
    version: 1,
    
    
    style: {
        width: null, //Key needs to be defined for it to be reactive
        borderColor: '#000000',
        radius: 0,
        color: ''
    }
};

const rowDefaults = {
    version: 1,
    
    
    style: {
        color: ''
    }
};

const columnDefaults = {
    version: 1,
    
    
    style: {
        mediaId: null,
        opacity: 0,
        backgroundColor: ''
    }
};

const buttonDefaults = {
    version: 1,
    
    
    text: 'KNOP!',
    link: null,
    
    style: {
        containerHeight: 26,
        width: 33,
        height: 100,
        backgroundColor: '#e0e0e0',
        borderColor: '#000000',
        borderRadius: 5,
        position: positions.center,
    }
};

const textDefaults = {
    version: 1,
    
    
    style: {
        horizontalMargin: 15,
        verticalMargin: 10
    }
};


const imageDefaults = {
    version: 1,
    
    
    mediaId: null,
    rotation: 0,
    
    tooltip: '',
    link: '',

    style: {
        size: 100,
        position: positions.center
    }
};

const applyDefaults = (defaults, target) => {
    Object.keys(defaults).forEach(key => {
        //For object defaults; we should copy the individual properties instead
        //of the complete object
        //null is considered an object by JS, therefor we need to explicitly exclude it
        //An object should still have it's missing keys copied over
        if((defaults[key] !== null) && typeof defaults[key] === 'object'){
            target[key] = applyDefaults(defaults[key], target[key] || {});
            return;
        }

        //Verify whether the target contains the given key in its proto chain
        if(key in target){
            return;
        }
        
        //Copying over the default value with the given key should do the trick
        target[key] = defaults[key];
    });
    
    return target;
};

export {
    applyDefaults,
    
    templateDefaults,
    pageDefaults,
    blockDefaults,
    rowDefaults,
    columnDefaults,
    
    buttonDefaults,
    textDefaults,
    imageDefaults
};